
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import QrCodeReader from "@/components/QrCodeReader.vue";
import SimpleDialog from "@/components/SimpleDialog.vue";
import {Getter} from "vuex-class";
import moment from "moment";
import Timeout = NodeJS.Timeout;
import { CONNECTED_BOX_PROVIDERS } from "@/utils/connectedBoxes";
import QrcodeVue from "qrcode.vue";
import KeyReturningDate from "@/components/keys/actions/KeyReturningDate.vue";
const masterlockWakeUpImage = require("@/assets/images/masterlock-wake-up.png");

const REFRESH_TIME_MILLI: number = 2000;
const CLOSE_COUNTDOWN: number = 30;

@Component({
    components: {
        QrCodeReader,
        SimpleDialog,
        QrcodeVue,
        KeyReturningDate,
    },
})
export default class KeyWithdrawConnected extends Vue {

    get relay(): any {
        return this.currentKey?.Relays?.find((r) => r.type === "AGENCY");
    }

    get currentConnectedBox(): any {
      return {
                ...(this.currentKey?.currentLocation?.Box as any)?.ConnectedBox,
                boxName: (this.currentKey?.currentLocation?.Box as any)?.name,
            };
    }

    get displaySimulateButton(): boolean {
        return this.mylobyEnv !== "production";
    }

    get isSnapaccess(): boolean {
      return this.currentConnectedBox?.provider === this.connectedBoxesProviders.SNAPACCESS;
    }

    get withdrawIcon(): string {
        return "icon-picto_retrait-myloby";
    }

    @Prop({default: {}})
    public currentKey: any;

    @Prop({default: false})
    public disabled: boolean;

    @Prop({default: false})
    public listView: boolean;

    @Getter private currentUser: any;
    @Getter private isAdmin: boolean;
    @Getter private isMobile: boolean;
    @Getter private mylobyEnv: string;

    private connectedCode: {
      code: string,
      id: number,
    } = null;
    private step1Modal: boolean = false;
    private step2Modal: boolean = false;
    private isLoading: boolean = false;
    private loadingSimulate: boolean = false;
    private keyNotInsideConfirmation: boolean = false;
    private confirmKeyNotInside: boolean = false;
    private lockerNotOpenConfirmation: boolean = false;
    private confirmLockerNotOpen: boolean = false;
    private intervalId: Timeout = null;
    private connectedBoxesProviders = CONNECTED_BOX_PROVIDERS;
    private canAddTagAtDrop: boolean = false;
    private retrieveOnlyBookedKey: boolean = false;
    private displayChooseHour: boolean = false;
    private estimatedEndDate: string = null;
    private canGuestChooseReturnHour: boolean = false;
    private displayDeviceNotReadyHelp: boolean = false;
    private masterlockWakeUpImage = masterlockWakeUpImage;

    private countdown: number = CLOSE_COUNTDOWN;
    private countdownInterval: ReturnType<typeof setInterval> | null = null;

  @Watch("currentKey")
  public handlerKeyChange(newVal, oldValue) {
    if (newVal && (newVal.id !== oldValue?.id)) {
      this.fetchRelayOptions();
    }
  }

  private async fetchRelayOptions() {
    if (this.relay) {
      if (this.currentLocationRelay) {
        // Potential withdraw
        this.retrieveOnlyBookedKey = await this.$store.dispatch("options/readOptionValueByRelay", {
          relayId: this.relay.id,
          optionTypeLabel: "retrieveOnlyBookedKey",
        });
      } else {
        // Potential drop (unused by the way ?)
        this.canAddTagAtDrop = await this.$store.dispatch("options/readOptionValueByRelay", {
          relayId: this.relay.id,
          optionTypeLabel: "canAddTagAtDrop",
        });
      }
    }
    if (this.currentLocationBuilding) {
      this.canGuestChooseReturnHour = await this.$store.dispatch("options/readOptionValueByBuilding", {
        buildingId: this.currentLocationBuilding.id,
        optionTypeLabel: "canGuestChooseReturnHour",
      });
    }
  }

  private mounted(): void {
    if (this.currentKey) {
      this.fetchRelayOptions();
    }
  }

  get currentLocationBuilding(): any {
    return this.currentKey?.currentLocation?.Box?.Building;
  }

  get currentLocationRelay(): any {
    return this.currentLocationBuilding?.Relays?.[0];
  }

    get currentLocation(): any {
        return this.currentKey?.KeyLocation?.find((kL) => !kL.endDate)?.Location;
    }

    get isKeyInConnectedBox(): boolean {
      return !!this.currentLocation?.Box?.ConnectedBox;
    }

    get canWithdraw(): boolean {
      return this.isKeyInConnectedBox
        && !this.isKeyBookedForOtherUser
        && (
          this.isAdmin
          || this.retrieveOnlyBookedKey === false
          || this.isKeyBookedForCurrentUser
        );
    }

    get isKeyBookedForOtherUser(): boolean {
      return this.currentKey?.currentBooking ? this.currentKey.currentBooking.userId !== this.currentUser?.id
        && moment().isAfter(moment(this.currentKey.currentBooking.startDate))
        && moment().isBefore(moment(this.currentKey.currentBooking.endDate)) : false;
    }

    get isKeyBookedForCurrentUser(): boolean {
      return this.currentKey?.currentBooking ? this.currentKey.currentBooking.userId === this.currentUser?.id
        && moment().isAfter(moment(this.currentKey.currentBooking.startDate))
        && moment().isBefore(moment(this.currentKey.currentBooking.endDate)) : false;
    }

    private startCountdown(): void {
        if (this.countdownInterval) {
            return;
        }
        this.countdown = CLOSE_COUNTDOWN;

        this.countdownInterval = setInterval(() => {
            if (this.countdown > 0) {
                this.countdown--;
            }
        }, 1000);
    }

    private stopCountdown(): void {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
            this.countdownInterval = null;
        }
    }

    private withdrawFromConnected(askNewCode: boolean = false) {
        clearInterval(this.intervalId);
        this.connectedCode = null;
        this.displayDeviceNotReadyHelp = false;
        this.connectedCode = null;
        this.isLoading = true;
        this.step1Modal = true;
        this.$store.dispatch("keys/withdrawFromConnected", {
            keyId: this.currentKey.id,
            transferService: this.currentConnectedBox.provider,
            askNewCode,
            estimatedEndDate: this.estimatedEndDate,
        }).then((res) => {
            this.connectedCode = {
              id: res.connectedCodeId,
              code: res.connectedCodeCode,
            };
            this.intervalId = setInterval(() => this.checkConnectedKeyMove(), REFRESH_TIME_MILLI);
        }).catch((error) => {
          if (error?.response?.data?.name === "BOX_NOT_READY") {
            this.displayDeviceNotReadyHelp = true;
            this.isLoading = false;
          } else {
            this.$store.commit("alerts/displayHttpError", {
              error,
              icon: "icon-picto_retrait-agence",
            });
            this.closeModals();
          }
        });
    }

    private checkConnectedKeyMove(): Promise<void> {
        return this.$store.dispatch("keys/getConnectedKeyMove", {
            id: this.currentKey.id,
            connectedCodeId: this.connectedCode.id,
        }).then((data) => {
            if (data?.step?.name === "WAITING_CLOSE_LOCK" || data?.step?.name === "COMPLETED") {
              // Code has been used => go to the second step of the workflow
                clearInterval(this.intervalId);
                this.step1Modal = false;
                this.step2Modal = true;
                this.startCountdown();
                this.intervalId = setInterval(() => this.checkWorkflowOver(), REFRESH_TIME_MILLI);
            } else if (data?.step?.name === "CANCELLED" || !data) {
                // ConnectedKeyMove has been cancelled or automatically deleted
                this.stopCountdown();
                this.errorCallback(this.$i18n?.t(`alerts.error.${data?.step?.message || "transactionExpired"}`));
            }
        }).catch((err) => {
            this.errorCallback(err);
        });
    }

    private checkWorkflowOver(): Promise<void> {
        return this.$store.dispatch("keys/getKeyStatus", {
            id: this.currentKey.id,
        }).then((data) => {
            // @TODO: [NIW] Move when factorized
            const workflow: string = "WITHDRAW";
            // const keyDropped: boolean = workflow === "DROP" && data === "IN_RELAY";
            const keyWithdrawn: boolean = workflow === "WITHDRAW" && data === "WITH_SOMEBODY";
            if (/*keyDropped || */keyWithdrawn) {
                // @TODO: [NIW] Create dynamic messages with workflow
                // this.$store.commit("alerts/displaySuccess", {
                //     icon: "icon-picto_depot-agence",
                //     msg: this.$i18n?.t("alerts.key.dropSuccess", {
                //         key: this.currentKey.name,
                //         relay: this.relay.name,
                //     }),
                // });
                this.$store.commit("alerts/displaySuccess", {
                    icon: "icon-picto_rapatrier",
                    msg: this.$i18n?.t("alerts.key.retrieveSuccess", {key: this.currentKey.name}),
                });
                this.$store.dispatch("context/clearContext");
                this.reset();
            }
        }).catch((err) => {
            this.errorCallback(err);
        });
    }

    private async simulateCodeUse(): Promise<void> {
        this.loadingSimulate = true;
        await this.$store.dispatch("connectorConnectedBoxes/simulateCodeUse", {
            externalId: this.currentConnectedBox.externalId,
            code: this.connectedCode.code,
        }).then(() => {
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$t("key.actions.connectedBox.simulateAction"),
            });
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.loadingSimulate = false;
        });
    }

      private cancel() {
          this.step1Modal = false;
          this.step2Modal = false;
          this.stopCountdown();
          clearInterval(this.intervalId);
      }

    private lockerIsNotOpenConfirmation(): void {
        this.lockerNotOpenConfirmation = true;
    }

    private lockerNotOpen() {
        this.$store.dispatch("keys/lockerNotOpen", {
            keyId: this.currentKey.id,
            connectedCodeId: this.connectedCode.id,
        }).then(() => {
            this.reset();
            this.$store.commit("alerts/displaySuccess", {
                icon: "icon-picto_depot-agence",
                msg: this.$i18n?.t("common.emailSent"),
            });
        });
    }

    private keyIsNotInside() {
        this.$store.dispatch("keys/keyIsNotInside", {
            keyId: this.currentKey.id,
            connectedCodeId: this.connectedCode.id,
        }).then(() => {
            this.reset();
            this.$store.commit("alerts/displaySuccess", {
                icon: "icon-picto_depot-agence",
                msg: this.$i18n?.t("common.emailSent"),
            });
        });
    }

    private errorCallback(msg: any) {
        this.$store.commit("alerts/displayError", { msg });
        this.reset();
    }

    private reset(): void {
        this.closeModals();
        this.$emit("reset");
    }

    private closeModals(): void {
        this.isLoading = false;
        this.step1Modal = false;
        this.step2Modal = false;
        this.keyNotInsideConfirmation = false;
        this.lockerNotOpenConfirmation = false;
        this.connectedCode = null;
        this.stopCountdown();
        clearInterval(this.intervalId);
    }

    private beforeDestroy(): void {
        clearInterval(this.intervalId);
    }
    private validateTime(value) {
        this.estimatedEndDate = (new Date(value)).toISOString().substr(0, 19);
        this.displayChooseHour = false;
        this.withdrawFromConnected();
    }
    private async buttonClick() {
        if (this.canGuestChooseReturnHour) {
             this.displayChooseHour = true;
        } else {
            this.withdrawFromConnected();
        }
    }

}
